import {AutomationFilter} from './reducer/model';
import {RuleFilters, RuleType} from './enums';
import {allowAISearch} from '../../_legacy/Searches/components/AISearch/utils';
import {getAlertFlag} from '../../_shared/GWTBridge/invoke/genPage';
import {formsStore} from '../../stores/Form/FormsStore';
import {formsStore as legacyFormsStore} from '../../_legacy/Form/stores/FormsStore';

type OptionData = {
    value: string | number | boolean;
    label: string;
};

type MapAppliedFiltersType = {
    [RuleFilters.ruleAction]: OptionData[];
    [RuleFilters.validFor]: OptionData[];
    [RuleFilters.updatedBy]: OptionData[];
    [RuleFilters.isActive]: OptionData[];
};

export const mapAppliedFilters = (appliedFilters: Array<AutomationFilter>) =>
    appliedFilters.reduce((acc, curr) => {
        if (!acc[curr.name]) {
            acc[curr.name] = [];
        }
        acc[curr.name].push(curr.option);
        return acc;
    }, {} as MapAppliedFiltersType);

export const isAlertSuperUser = () => {
    return Boolean(formsStore.sysConstants?.alertflag?.Int) || getAlertFlag();
};

export const multiOptionsHaveValidValue = (data?: number[]) =>
    data && data.filter(val => Boolean(val)).length > 0;

export const supportAIBlock = () => {
    return allowAISearch();
};

export const getRuleKeyByValue = (value: RuleType) => {
    return Object.keys(RuleType).find(key => RuleType[key] === value) || '';
};

export const getIsHtmlForm = () => {
    return Boolean(legacyFormsStore?.currentForm?.isHTML);
};
